var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { ChartSeriesVisibility } from '@web/components/layout/RechartsItems/ChartSeriesVisibility';
import { createEdgePositionedBarTooltipContent } from '@web/components/layout/RechartsItems/EdgePositionedBarTooltip';
import LegendItem from '@web/components/layout/RechartsItems/LegendItem';
import { rechartsDiagonalStripeFillUrl, rechartsDiagonalStripePatternDefs } from '@web/components/layout/RechartsItems/rechartsDiagonalStripes';
import { Widget } from '@web/components/layout/Widget';
import { WidgetChartPlotArea } from '@web/components/layout/WidgetChartPlotArea/WidgetChartPlotArea';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { InvocationsByActionTooltipContent } from '@web/components/layout/WidgetTooltips/InvocationsByActionTooltip';
import { INVOCATIONS_BY_ACTION_COLORS_CONFIG, RECHARTS_STACK_BAR_WHITE_STROKE } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled } from '@web/utility';
import { ComparisonPeriod, navigateChartPeriodBarClick } from '@web/utility/chartNavigation';
import { applyMinBarHeight, calculateMinBarHeight, formatChartDayPeriodAxisLabel, getPeriodBarChartLayoutProps, isBarChartRowsEmpty } from '@web/utility/charts';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { AnalyticPeriodsEnum, InsightTypeEnum } from '@workalizer/shared/enums';
import { getInterval } from '@workalizer/shared/utils';
import { getInvocationsChartPeriodKeys } from '@workalizer/shared/utils/geminiInvocationsChart';
import { useTranslation } from 'react-i18next';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
var invocationsByActionTeamStripePatternId = function (appName) {
    return "".concat(InsightTypeEnum.invocationsByAction, "_team-").concat(appName);
};
var findPeriodByChartLabel = function (periods, label, interval, dateFrom, dateTo) {
    var _a;
    var dayRange = { dateFrom: dateFrom, dateTo: dateTo };
    return ((_a = periods.find(function (period) {
        return period.period === label ||
            formatChartDayPeriodAxisLabel(period.period, interval, dayRange) ===
                label;
    })) !== null && _a !== void 0 ? _a : null);
};
export var InvocationsByAction = function (_a) {
    var _b;
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var _c = trpc.invocationsByApp.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }), data = _c.data, isLoading = _c.isLoading, refetch = _c.refetch;
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var interval = getInterval(dateFrom, dateTo);
    var periodKeys = getInvocationsChartPeriodKeys(userId);
    var apps = (_b = data.chartAppNames) !== null && _b !== void 0 ? _b : [];
    var stackApps = __spreadArray([], apps, true).reverse();
    var teamStripePatternEntries = stackApps.map(function (appName) { return ({
        patternId: invocationsByActionTeamStripePatternId(appName),
        chartColor: INVOCATIONS_BY_ACTION_COLORS_CONFIG.team[appName].chartColor
    }); });
    var maxValue = Math.max.apply(Math, data.periods.flatMap(function (period) {
        return periodKeys
            .filter(function (key) { return key !== 'team' || period.team; })
            .flatMap(function (periodKey) {
            var appRecord = period[periodKey];
            return apps.map(function (appName) { var _a; return (_a = appRecord[appName]) !== null && _a !== void 0 ? _a : 0; });
        });
    }));
    var minBarHeight = calculateMinBarHeight(maxValue, 0.025, 2);
    var chartData = data.periods.map(function (period) {
        var entry = {
            label: period.period
        };
        periodKeys.forEach(function (periodKey) {
            if (periodKey === 'team' && !period.team) {
                return;
            }
            var appRecord = period[periodKey];
            apps.forEach(function (appName) {
                var _a;
                var value = (_a = appRecord[appName]) !== null && _a !== void 0 ? _a : 0;
                entry["".concat(periodKey, "-").concat(appName)] = applyMinBarHeight(value, minBarHeight);
            });
        });
        return entry;
    });
    var _d = getPeriodBarChartLayoutProps({
        barGroupCount: chartData.length,
        barsPerGroup: userId ? 3 : 2
    }), barGap = _d.barGap, barSize = _d.barSize, periodXAxis = _d.periodXAxis, periodBarChartMargin = _d.periodBarChartMargin;
    var chartPlotEmpty = isBarChartRowsEmpty(chartData);
    var legendItems = apps.map(function (appName) { return ({
        appName: appName,
        label: t("app.performanceReview.employeePerformanceReview.aiAdoptionAndUsageSection.tablesData.apps.".concat(appName)),
        colorClass: INVOCATIONS_BY_ACTION_COLORS_CONFIG.currentPeriod[appName].color
    }); });
    var renderTooltip = createEdgePositionedBarTooltipContent(function (tooltipProps) {
        var active = tooltipProps.active, label = tooltipProps.label;
        if (!active || !label) {
            return null;
        }
        var periodData = findPeriodByChartLabel(data.periods, String(label), interval, dateFrom, dateTo);
        if (!periodData) {
            return null;
        }
        return (_jsx(InvocationsByActionTooltipContent, { periodData: periodData, appNames: apps, dateFrom: dateFrom, dateTo: dateTo, userId: userId, t: t }));
    }, chartData.length);
    var titleText = t('app.performanceReview.employeePerformanceReview.aiAdoptionAndUsageSection.invocationsByAction');
    var descriptionText = t(userId
        ? 'widgetTitleDescriptions.aiAdoptionAndUsage.invocationsByActionUser'
        : 'widgetTitleDescriptions.aiAdoptionAndUsage.invocationsByActionTeam');
    var exportData = data.periods.map(function (period) {
        var _a;
        var dateLabel = interval === AnalyticPeriodsEnum.DAY
            ? formatChartDayPeriodAxisLabel(period.period, interval, {
                dateFrom: dateFrom,
                dateTo: dateTo
            })
            : period.period;
        var entry = (_a = {},
            _a[t('app.apps.searchMeetings.filters.date')] = dateLabel,
            _a);
        apps.forEach(function (appName) {
            var _a, _b, _c;
            var appLabel = t("app.performanceReview.employeePerformanceReview.aiAdoptionAndUsageSection.tablesData.apps.".concat(appName));
            var current = (_a = period.currentPeriod[appName]) !== null && _a !== void 0 ? _a : 0;
            var previous = (_b = period.previousPeriod[appName]) !== null && _b !== void 0 ? _b : 0;
            entry["".concat(appLabel, " (").concat(t('export.current'), ")")] = current;
            entry["".concat(appLabel, " (").concat(t('export.previous'), ")")] = previous;
            if (period.team) {
                entry["".concat(appLabel, " (Team)")] = (_c = period.team[appName]) !== null && _c !== void 0 ? _c : 0;
            }
        });
        return entry;
    });
    var handleBarClick = function (periodKey, barData, fallbackIndex) {
        var teamScope = periodKey === 'team';
        navigateChartPeriodBarClick({
            chartData: data.periods,
            barData: barData,
            fallbackIndex: fallbackIndex,
            stack: periodKey === 'previousPeriod'
                ? ComparisonPeriod.Previous
                : ComparisonPeriod.Current,
            destination: { kind: 'apps', tab: 'gemini' },
            navigateTo: navigateTo,
            dateFrom: dateFrom,
            dateTo: dateTo,
            userId: teamScope ? null : userId,
            orgUnitId: orgUnitId
        });
    };
    return (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(WidgetTitle, { title: titleText, description: descriptionText, insightType: InsightTypeEnum.invocationsByAction, insightsData: data.periods, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: titleText, onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2 /*return*/, exportData];
                    }); }); }, disabled: isAiButtonDisabled(data.periods) }) }), _jsx(ChartSeriesVisibility, __assign({ seriesKeys: apps }, { children: function (_a) {
                    var toggleSeries = _a.toggleSeries, isSeriesVisible = _a.isSeriesVisible;
                    return (_jsxs(Widget, __assign({ className: "w-full py-2", cardClassName: "shadow border-b border-gray-200 sm:rounded-lg p-6" }, { children: [_jsx("div", __assign({ className: "flex flex-wrap gap-x-6 gap-y-3 mb-6" }, { children: legendItems.map(function (_a) {
                                    var appName = _a.appName, label = _a.label, colorClass = _a.colorClass;
                                    return (_jsx(LegendItem, { color: colorClass, label: label, onClick: function () { return toggleSeries(appName); }, isHidden: !isSeriesVisible(appName) }, appName));
                                }) })), _jsx(WidgetChartPlotArea, __assign({ isEmpty: chartPlotEmpty }, { children: _jsx(ResponsiveContainer, __assign({ width: "100%", height: 420 }, { children: _jsxs(BarChart, __assign({ data: chartData, barGap: barGap, barSize: barSize, margin: periodBarChartMargin }, { children: [userId &&
                                                rechartsDiagonalStripePatternDefs(teamStripePatternEntries), _jsx(CartesianGrid, { strokeDasharray: "3 3", stroke: "#f3f4f6" }), _jsx(XAxis, __assign({ dataKey: "label", axisLine: false, tickLine: false }, periodXAxis, { tickFormatter: function (value) {
                                                    return formatChartDayPeriodAxisLabel(value, interval, {
                                                        dateFrom: dateFrom,
                                                        dateTo: dateTo
                                                    });
                                                } })), _jsx(YAxis, { axisLine: false, tickLine: false, tick: { fontSize: 12, fill: '#6b7280' }, tickFormatter: function (value) { return String(value); } }), _jsx(Tooltip, { allowEscapeViewBox: { x: true, y: true }, content: renderTooltip }), periodKeys.map(function (periodKey) {
                                                var stackId = periodKey === 'currentPeriod'
                                                    ? 'current'
                                                    : periodKey === 'previousPeriod'
                                                        ? 'previous'
                                                        : 'team';
                                                return stackApps.map(function (appName) {
                                                    var colors = INVOCATIONS_BY_ACTION_COLORS_CONFIG[periodKey][appName];
                                                    var fill = periodKey === 'team'
                                                        ? rechartsDiagonalStripeFillUrl(invocationsByActionTeamStripePatternId(appName))
                                                        : colors.chartColor;
                                                    var radius = [
                                                        4, 4, 4, 4
                                                    ];
                                                    return (_jsx(Bar, __assign({ dataKey: "".concat(periodKey, "-").concat(appName), stackId: stackId, fill: fill, radius: radius, hide: !isSeriesVisible(appName), style: { cursor: 'pointer' }, onClick: function (barData, index) {
                                                            return handleBarClick(periodKey, barData, index);
                                                        } }, RECHARTS_STACK_BAR_WHITE_STROKE), "".concat(periodKey, "-").concat(appName)));
                                                });
                                            })] })) })) }))] })));
                } }))] })));
};
